export default function (context) {
  // Add the userAgent property to the context
  const userAgent = process.server
    ? context.req.headers['user-agent']
    : navigator.userAgent;
  context.store.commit('setMobile', /iPhone|iPad|iPod|Android|Windows Phone/.test(userAgent));
}